import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { tInvtService } from "src/app/services/tInvt.server";
import { LoggerService } from "src/app/services/Non-Master/logger.service";
import { TranslateService } from "@ngx-translate/core";
import { DateTimeConvertService } from "src/app/services/CommonService/DateTimeConvert.service";
import { tInvtModel_PrintModel, tInvtModel } from "src/app/models/tInvtModel";
import { NavigationComponent } from "src/app/pages/navigation/navigation.component";
import { ChineseDefaultModel } from "src/app/models/non-master-model/SystemDefaultModel";
import { GRNCateCode } from "src/app/models/non-master-model/GRNCateCode";
import { DatePipe, Location } from "@angular/common";
import { UnitMediPurchaseModel } from "src/app/models/UnitMediPurchaseModel";
import { UnitMediStockModel } from "src/app/models/UnitMediStockModel";
import { UnitItemModel } from "src/app/models/UnitItemModel";
import { UnitMediPurchaseService } from "src/app/services/Unit/UnitMediPurchase.service";
import { UnitMediStockService } from "src/app/services/Unit/UnitMediStock.service";
import { UnitItemService } from "src/app/services/Unit/UnitItem.service";
import { AppSettings } from "src/app/shared/AppSettings";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { tOnConsultService } from "src/app/services/tOnConsult.service";

@Component({
  selector: "app-clinical-notes",
  templateUrl: "./clinical-notes.component.html",
  styleUrls: ["./clinical-notes.component.css"],
})
export class ClinicalNotesComponent implements OnInit {

  @Input() consultNumber: string;

  @ViewChild("printBtn") printBtn: ElementRef<HTMLElement>;


  n = {
    consultation: {
      clthConsultNumber: "CTXXX123123123",
      clthTherapistID: "JF",
      therapistName: "",
      therapistChristianName:"Dr. Jason Fan",
      clthDiagonsis: "RIGHT CHEST INJURY",
      prescriptionDate: "",
      notes:"",
      doctorOrder:"a\nasasdasdasd\nas",
      arrivalDate:"dd/mm/yyyy",
      clthCaseDrID:""
    },
    patient: {
      patientID: "96701",
      patientChiName: "鄧志恒",
      patientSurname: "Tang Chi Hang",
      gender: "M",
      dob:"1990-04-03",
      age:"30"

    },
    prescDetails: [],
  };

  TAG = "ClinicalNotesComponent";

  printTime = "";

  public invtDocNumber: string;

  public display_printDateTime;
  public display_selectedShopName: string;
  public display_postDate: string;
  public display_fromToWhsName: string;
  public display_itemTypeName: string;
  public display_totalAmount: number = 0;

  mediPurchaseUnitList: UnitMediPurchaseModel[];
  mediStockUnitList: UnitMediStockModel[];
  stockItemUnitList: UnitItemModel[];

  constructor(
    public modal : NgbActiveModal,
    private translate: TranslateService,
    private consultService : tOnConsultService,

    private datePipe:DatePipe
  ) {
    let currentLanguage = localStorage.getItem("currentLanguage");
    translate.use(currentLanguage);
  }

  private data_list: tInvtModel_PrintModel;
  public dataList_tInvtModel: tInvtModel[];

  ngOnInit() {
    this.setPrintTime();
    // console.log("consultNumber = "+this.consultNumber);
    this.getClinicalNotes(this.consultNumber);
  }

  back() {
    this.modal.dismiss();
  }

  formatDate(){
    return"";
  }

  getClinicalNotes(consultNumber:string){
    this.consultService.getPrintClinicalNotes(consultNumber).subscribe(x=>{
      this.n = x.data;
    });
  }

  setPrintTime(){
    this.printTime = this.datePipe.transform(new Date(),"dd/MM/yyyy HH:mm");
  }

  print(){
    this.setPrintTime();
    console.log(this.printTime);
    setTimeout(() => {
      this.printBtn.nativeElement.click();
    });
  }

}
